<h1 mat-dialog-title class="active" [class.caption-touch]="touch == true">{{ caption | translate }}</h1>

<mat-dialog-content>
    <p [class.message-touch]="touch == true">
        {{ message | translate : messageParams }}
    </p>
</mat-dialog-content>

<div [class.actions-touch]="touch == true" mat-dialog-actions style="border-top: 1px solid lightgrey;">
    <button mat-stroked-button
            *ngIf="showReject"
            color="primary"
            [mat-dialog-close]="false"
            [class.medium-touch-btn]="touch == true">
        {{ rejectLabel | translate }}
    </button>
    <button mat-flat-button cdkFocusInitial
            [mat-dialog-close]="true"
            color="primary"
            class="accept-btn medium-touch-btn">
        {{ acceptLabel | translate }}
    </button>
</div>
